module.exports = __webpack_public_path__ + "static/img/icon3.3a6572de.gif";